enum BookingPrivacyType {
    MeetingType = 0,
    PrivateMeetingType = 1,
}

export default BookingPrivacyType;
